import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { ContactSiteData } from './contactSite.api'
import { CustomerData } from './customer.api'
import { VendorData } from './vendor.api'

export type ContactableType = 'customer' | 'vendor'
type Contactable = CustomerData | VendorData

export interface ContactData {
  id: number
  contactableId: number
  deletedBy?: number
  contactableType: ContactableType
  deletedAt?: string
  isDeleted: boolean
  contactable?: Contactable
  customer?: CustomerData
  vendor?: VendorData
  sites?: ContactSiteData[]
}

interface ContactCreateRequestSite {
  name: string
  address: string
  city: string
  state: string
  zip: string
}

interface ContactUpdateRequestSite extends ContactCreateRequestSite {
  id: number
}

export interface ContactCreateRequest {
  contact?: ContactableType
  name?: string
  sites?: ContactCreateRequestSite[]
}

export interface ContactUpdateRequest {
  name?: string
  sitesCreated?: ContactCreateRequestSite[]
  sitesUpdated?: ContactUpdateRequestSite[]
  sitesDeleted?: number[]
}

const routes = {
  list: '/contacts',
  delete: '/contacts/{id}',
  create: '/contacts',
  read: '/contacts/{id}',
  update: '/contacts/{id}',
  search: '/contacts/search'
}

export default {
  list (callback: ResponseCallback<ContactData[]>) {
    api.get(routes.list, {}, callback)
  },

  delete (id: number, callback: ResponseCallback<ContactData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  create (
    payload: ContactCreateRequest,
    callback: ResponseCallback<ContactData>
  ) {
    api.post(routes.create, payload, callback)
  },

  read (id: number, callback: ResponseCallback<ContactData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: ContactUpdateRequest,
    callback: ResponseCallback<Contactable>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  },

  search (contact: string, callback: ResponseCallback<ContactData[]>) {
    const params = { contact }
    api.get(routes.search, params, callback)
  }
}
